export default __webpack_public_path__ + "static/media/Infosquareback-background.c0d2209d.svg";